<div class="skl-card" aria-busy="true" aria-label="Loading job log table">
  <div class="skl-card__header">
    <app-skeleton width="160px" height="16px" borderRadius="4px" marginBottom="0"></app-skeleton>
  </div>
  <div class="skl-card__body">
    <div class="skl-table-wrap">
      <div class="skl-row skl-row--header">
        @for (col of cols; track col) {
          <div class="skl-cell">
            <app-skeleton [width]="col === 1 ? '70%' : col === 8 ? '44%' : '62%'" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
          </div>
        }
      </div>

      <div class="skl-row skl-row--filters">
        @for (col of cols; track col) {
          <div class="skl-cell">
            @if (col <= 2) {
              <app-skeleton width="100%" height="34px" borderRadius="4px" marginBottom="0"></app-skeleton>
            } @else if (col === 8) {
              <app-skeleton width="32px" height="32px" borderRadius="4px" marginBottom="0"></app-skeleton>
            }
          </div>
        }
      </div>

      @for (row of rows; track row) {
        <div class="skl-row skl-row--data">
          @for (col of cols; track col) {
            <div class="skl-cell">
              @if (col === 2 || col === 3 || col === 4 || col === 5) {
                <app-skeleton width="76px" height="20px" borderRadius="10px" marginBottom="0"></app-skeleton>
              } @else if (col === 8) {
                <app-skeleton width="84px" height="30px" borderRadius="4px" marginBottom="0"></app-skeleton>
              } @else {
                <app-skeleton [width]="col === 1 ? '84%' : col === 6 ? '46%' : col === 7 ? '72%' : '58%'" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
              }
            </div>
          }
        </div>
      }
    </div>

    <div class="skl-pagination">
      <app-skeleton width="220px" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
      <div class="skl-pagination-buttons">
        @for (btn of [1, 2, 3, 4]; track btn) {
          <app-skeleton width="32px" height="32px" borderRadius="4px" marginBottom="0"></app-skeleton>
        }
      </div>
    </div>
  </div>
</div>